import LoadingIndicator from "assets/svg/loading-indicator";
import Button from "components/button/button";
import { Context } from "context/context";
import { useContext } from "react";

export default function CustomTemplateDetails({
  handleChangeStep = () => console.log("We are missing a function here"),
  loading = false,
}) {
  const { setSelectedTab } = useContext(Context);
  return (
    <div className="w-full">
      {/* header */}
      <div className="w-full">
        <p className="font-medium text-2xl">Add Your Content</p>
      </div>
      <div className="w-full pt-5">
        {/* left card start */}
        <div
          className="bg-white rounded-xl relative campaign-left-max"
          style={{ height: "fit-content" }}
        >
          <div className="p-5">
            {/* first */}
            <div className="pl-1 pb-2">
              <p className="text-xl mt-1">Custom Template</p>
              <p className="mt-2">
                This is a custom template configured for you by the
                ConversionCow team. It cannot be changed by users.
              </p>
              <p className="mt-2">
                Please{" "}
                <a
                  href="mailto:support@conversioncow.com"
                  className="underline text-secondary"
                >
                  contact us
                </a>{" "}
                if you need changes made.
              </p>
            </div>
          </div>
          {/* footer */}
          <div className="border-t border-tabBorder">
            <div className="flex flex-row flex-1 justify-end p-5 space-x-10">
              <Button
                buttonName="PREVIOUS"
                buttonClass="bg-transparent rounded-full py-3"
                buttonType="transparent"
                buttonTextClass="text-sm font-bold"
                onClick={() => setSelectedTab("template")}
              />
              <Button
                buttonName="NEXT"
                buttonClass="relative bg-primary rounded-full py-3 px-12"
                buttonType="primary"
                onClick={handleChangeStep}
                disabled={loading}
                icon={
                  loading && (
                    <div className="absolute right-2 bottom-0 top-0 flex items-center">
                      <LoadingIndicator className="text-white w-4 h-4" />
                    </div>
                  )
                }
              />
            </div>
          </div>
          {/*  */}
        </div>
      </div>
    </div>
  );
}
